module.exports = __webpack_public_path__ + "img/ludogorets-logo-icon.abcf2172.png";